import { CropMode } from '../../../../apps/studio/src/utils/types';

export enum TemplateVisibility {
    'SHOW' = 'SHOW',
    'HIDE' = 'HIDE',
}

export interface IProjectTemplate {
    cropMode: CropMode;
    id: string;
    name: string;
    rank: number;
    rawDataUrl: string;
    previewUrl: string;
    videoUrl?: string;
    scenesCount: number;
    scenesThumbnailsUrls: string[];
    tags: string[];
    visibility: TemplateVisibility;
}

export enum VisibilityFilter {
    ALL = 'all',
    HIDDEN = 'hidden',
    VISIBLE = 'visible',
}

export interface CreateTemplateFormData {
    srcProjectId: string;
    templateName: string;
    tags?: string[];
    fonts: {
        primary: string;
        secondary?: string;
        tertiary?: string;
    };
    colors: {
        primary: string;
        secondary?: string;
        tertiary?: string;
    };
    rank: number;
    visibility: TemplateVisibility;
}

export type UpdateTemplateFormData = Omit<CreateTemplateFormData, 'srcProjectId'>;
